export { default as withPaths } from './withPaths';
export * from './withPaths';
